<template>
	<div class="bb-panel-wrapper">
		<section class="b360-section-container">
			<span class="b360-form-label" role="heading"
				>Select a {{ selectContent }}</span
			>
			<BbDesignCard
				v-for="(card, index) in selectContentArray"
				:key="index"
				:card="card"
				@click.native="selectCard(card)"
				@keydown.enter="selectCard(card)"
				:class="{ selected: card.index === selectDesign.index }"
			/>
		</section>
	</div>
</template>

<script>
import BbDesignCard from '@/components/brand-builder/bb-design/BBDesignCard.vue';
import { mapState, mapActions } from 'vuex';

export default {
	name: 'BbSelectContent',
	components: {
		BbDesignCard,
	},
	computed: mapState({
		selectDesign: (state) => state.brandBuilderEditor.selectedVideo,
		selectContent: (state) =>
			state.brandBuilderEditor.selectVideo[0].contentType,
		selectContentArray: (state) =>
			state.brandBuilderEditor.selectVideo[0].fakeDataArray,
	}),
	methods: {
		...mapActions(['selectVideo']),
		selectCard(card) {
			this.selectVideo(card);
			// TODO: Refactor
			const checkBox = document.querySelector(`#select-card-${card.index}`);
			checkBox.checked = true;
		},
	},
};
</script>

<style lang="scss" scoped>
.b360-btn--workspace-secondary {
	margin-bottom: 15px;
}
</style>
